export const environment = {
    production: false,
    isDevMode: true,
    cognito: {
        UserPoolId: 'us-east-2_U3IumOoQm',
        ClientId: '26604n6hr79bprnal3qrpuo1pl',
        ProviderUrl: 'https://dev-service-manual-tool.auth.us-east-2.amazoncognito.com/oauth2/authorize',
        IdentityProvider: 'UnitedRentalsSAMLProvider'
    },
    integrations: {
        make: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/makes',
        model: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/models',
        serialNumber: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/serial-numbers',
        serialNumberRange: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/serial-ranges',
        bySerialRange: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/manual-by-serial-range',
        byPvc: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/manual-by-pvc',
        equipmentByCode: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/manual-by-code',
        equipmentDetails: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/equipment_details',
        pvc: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/pvc-codes',
        prompts: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/get-prompts',
        chatQuestionData: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/questionData',
        genericQuery: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/genericQuery',
        features: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/features',
        chatQuestionDataSerialRange: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/questionData-serialRange',
        chatSocket: 'wss://manual-api-wss.us-east-2.innovdev.aws.ur.com/production',
        transactionFeedback: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/transactionData',
        transactions: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/transactions',
        adminResources: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/resources',
        adminMake: "https://manual-api.us-east-2.innovdev.aws.ur.com/admin/makes",
        manualDownload: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/manual-download',
        deleteResource: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/pdf-resource',
        manualUpload: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/manual-upload',
        manualCheck: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/manual-check',
        addCommonPrompt: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/common-prompt',
        deleteCommonPrompt: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/common-prompt',
        statistics: {
            makes: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/make-aggregated',
            models: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/model-aggregated',
            makemodels: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/make-aggregated-models',
            statisticsResources: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/statistics-resources',
        },
        manualType: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/manual-type',
        adminManualType: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/manual-type',
        duplicateResources: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/duplicate-resources',
        transactionsM2M: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/transactions-m2m',
        transactionsWebAI: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/transactions-webai',
        modelManualType: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/model-manual-type',
        validatePdf: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/validate-pdf',
        manualUploadStatus: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/manual-upload-status',
        bulkUpload: 'https://manual-api.us-east-2.innovdev.aws.ur.com/admin/bulk-upload',
        videoPresignedUrl: 'https://manual-api.us-east-2.innovdev.aws.ur.com/technician/video-presigned-url',
    },
    authCallBack: 'https://manual-tool.us-east-2.innovdev.aws.ur.com/auth/callback',
    pdfCloudFrontDomain: 'https://d1th97rajp1dv7.cloudfront.net/',
    maxPrompts: 7,
    websocketTimeoutMs: 16000,
};
